import { Directive } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
	selector: 'main[hlmSidebarInset]',
	host: { 'data-slot': 'sidebar-inset' },
})
export class HlmSidebarInset {
	constructor() {
		// Legacy Fuse maps Tailwind `md` to 960px. Restore the generated `md:*` variants after its breakpoint overrides are removed.
		classes(() => 'bg-background min-[768px]:peer-data-[variant=inset]:m-2 min-[768px]:peer-data-[variant=inset]:ms-0 min-[768px]:peer-data-[variant=inset]:rounded-xl min-[768px]:peer-data-[variant=inset]:shadow-sm min-[768px]:peer-data-[variant=inset]:peer-data-[state=collapsed]:ms-2 relative flex w-full flex-1 flex-col');
	}
}
